import React, { useState, useEffect, useRef } from 'react'
import { PLATFORM_VALUE } from 'meinian-package/src/component/platformConfig'
import request from 'meinian-package/src/utils/request'
import MNWaterfallApi from 'component/waterfall/masonryApi'
import { Spin } from 'antd'
import ZkItem from '../card/item'
import ZkIns from '../card/ins'
import DouyinItem from '../card/douyin/item'
import styles from './index.module.less'

export default ({ imgInfoList, rankStatus, platformId }) => {
  const [params, setParams] = useState({
    duplicateFilter: true,
    searchType: 1,
    pageNo: 1,
    pageSize: 24,
  })

  useEffect(() => {
    if (imgInfoList[0]?.boxLabelRetList?.[0]) {
      setParams({
        ...params,
        mainUrl: imgInfoList[0]?.mainUrl,
        box: imgInfoList[0].boxLabelRetList[0],
      })
      return
    }
    if (imgInfoList[0]?.mainUrl) {
      getBox()
    }
  }, [imgInfoList[0]?.mainUrl])

  const getBox = async () => {
    try {
      const box = await request.get(`/image-bus/get-box?mainUrl=${imgInfoList[0].mainUrl}`, { ignoreError: true })
      if (!(box && box[0])) {
        box[0] = { xmin: 0, ymin: 0, xmax: 1, ymax: 1 }
      }
      setParams({
        ...params,
        mainUrl: imgInfoList[0]?.mainUrl,
        box: box[0],
        rankStatus: 0,
      })
    } catch (error) {
      setParams({
        ...params,
        mainUrl: imgInfoList[0]?.mainUrl,
        box: { xmin: 0, ymin: 0, xmax: 1, ymax: 1 },
        rankStatus: 0,
      })
    }
  }

  const scrollRef = useRef(null)

  return <div className={styles.recommendList} ref={scrollRef}>
    {
      params.box ? platformId === PLATFORM_VALUE.DY ? <MNWaterfallApi
        root={scrollRef.current}
        key={platformId}
        cardKey={(item) => item.itemId}
        renderItem={DouyinItem}
        url="/zhikuan/image-bus/item/alike-dy-item"
        method="post"
        cardProps={{
          browseMode: 1,
        }}
        pageSize={24}
        params={{
          ...params,
          rankStatus: rankStatus.split(',')[0],
          sortOrderStatus: rankStatus.split(',')[1],
        }}
        emptyText="暂无相关款式"
      /> : <MNWaterfallApi
        root={scrollRef.current}
        key={platformId}
        renderItem={platformId === PLATFORM_VALUE.ITEM ? ZkItem : ZkIns}
        url="/zhikuan/image-bus/item/alike-inspiration"
        method="post"
        cardProps={{
          browseMode: 1,
        }}
        pageSize={24}
        params={{
          ...params,
          rankStatus: rankStatus.split(',')[0],
          sortOrderStatus: rankStatus.split(',')[1],
          platformIdList: [platformId]
        }}
        emptyText="暂无相关款式"
      /> : <Spin spinning>
        <div style={{ width: '100%' }} />
      </Spin>
    }
  </div>
}
